import React, { useState, useRef, useEffect } from "react";
import DateTimePopup from "./components/DateTimePopup";
import { icons } from "../../../../constants";
import "../../../../styles/global.css";

const DateTimePicker = ({
  value,
  onChange,
  className,
  placeholder,
  label,
  error,
  required,
  birthDate,
  classNameCalendar,
  registration_deadline,
}) => {
  console.log("reg", registration_deadline);
  const [showPicker, setShowPicker] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [hours, setHours] = useState(!registration_deadline ? "00" : "23");
  const [minutes, setMinutes] = useState(!registration_deadline ? "00" : "59");
  const ref = useRef(null);
  useEffect(() => {
    if (selectedDate) {
      const date =
        selectedDate instanceof Date ? selectedDate : new Date(selectedDate);
      const formattedDate = formatToYMD(date); // yyyy-mm-dd
      const time = `${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}`;
      const finalValue = `${formattedDate}T${time}`;
      onChange(finalValue); // example: "2025-05-07T07:00"
    }
  }, [selectedDate, hours, minutes]);

  useEffect(() => {
    if (value) {
      const [datePart, timePart] = value.split(/[ T]/);
      if (datePart && timePart) {
        const [year, month, day] = datePart.split("-");
        setSelectedDate(new Date(Number(year), Number(month) - 1, Number(day)));
        const [h, m] = timePart.split(":");
        if (h) setHours(h);
        if (m) setMinutes(m);
      }
    }
  }, [value]);

  const formatToYMD = (date) => {
    if (!(date instanceof Date)) {
      date = new Date(date);
    }
    if (isNaN(date)) return "";
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, "0");
    const day = `${date.getDate()}`.padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setTimeout(() => setShowPicker(false), 0);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      className={`flex-direction-column gap-8 relative width-100 date-time-picker ${classNameCalendar}`}
    >
      {label && (
        <div className="flex-direction-row items-center width-100 relative">
          {required && (
            <img
              src={icons.required}
              alt="req"
              width={12}
              height={12}
              style={{ position: "absolute", top: "0px", left: "0" }}
            />
          )}
          <label className="font-12 inria-sans-700">{label}</label>
        </div>
      )}

      <div ref={ref}>
        <div
          className={`flex-direction-row gap-8 items-center date-time-picker-input-wrapper ${
            error ? "invalid" : ""
          } `}
        >
          <input
            type="text"
            value={value}
            readOnly
            onClick={() => setShowPicker(true)}
            className={`inria-sans-300 font-12 ${className || ""}`}
            placeholder={placeholder}
          />
          <img
            src={icons.calendar}
            alt="calendar"
            width={24}
            height={24}
            onClick={() => setShowPicker(!showPicker)}
            style={{ cursor: "pointer" }}
          />
        </div>

        {showPicker && (
          <DateTimePopup
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            hours={hours}
            setHours={setHours}
            minutes={minutes}
            setMinutes={setMinutes}
            onChange={onChange}
            birthDate={birthDate}
            registration_deadline={registration_deadline}
          />
        )}
      </div>
    </div>
  );
};

export default DateTimePicker;
